<template>
<grid class="progress-bar">
	<grid-item size="1/1">
		<ul class="progressbar">
			<li v-for="index in countQuestions" :key="index"
				:class="{ active: index <= questionIndex }">
			</li>
		</ul>
	</grid-item>
</grid>

</template>

<script>
export default {
	props: ['questionIndex', 'countQuestions']
}
</script>

<style lang="scss">
.progress-bar {
	width: 60%;
	margin: 0 auto !important;

	ul {
		margin: 0;
		display: contents;

		li {
			list-style-type: none;
			width: 20%;
			float: left;
			font-size: 12px;
			position: relative;
			text-align: center;
			text-transform: uppercase;
			color: #7d7d7d;

			&:before {
				width: 16px;
				height: 16px;
				content: '';
				counter-increment: step;
				line-height: 30px;
				border: 2px solid #999999;
				display: block;
				text-align: center;
				margin: 0 auto 10px auto;
				border-radius: 50%;
				background-color: #999999;
			}
			&:after {
				width: 100%;
				height: 2px;
				content: '';
				position: absolute;
				background-color: #7d7d7d;
				top: 9px;
				right: 50%;
				z-index: -1;
			}
		}
		li:first-child:after {
			content: none;
		}
		li.active {
			color: #4ba98b;
		}
		li.active:before {
			border-color: #4ba98b;
			background-color: #4ba98b;
		}
		li.active:after {
			background-color: #4ba98b;
		}
	}

}
</style>
